import { render } from "./edit_sku.vue?vue&type=template&id=f498855e&scoped=true"
import script from "./edit_sku.vue?vue&type=script&lang=js"
export * from "./edit_sku.vue?vue&type=script&lang=js"

import "./edit_sku.vue?vue&type=style&index=0&id=f498855e&scoped=true&lang=css"

import exportComponent from "E:\\devops.aliyun\\liangting\\liangting_business_web\\seller.web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f498855e"]])

export default __exports__